import { DatePicker, type DatePickerSlotProps } from '@mui/x-date-pickers';
import { formatDate } from '@src/shared/lib';
import type { ComponentPropsWithoutRef, ComponentRef, ReactNode } from 'react';
import { forwardRef } from 'react';

type DateFieldProps = ComponentPropsWithoutRef<typeof DatePicker> & {
  required?: boolean;
  fullWidth?: boolean;
  helperText?: ReactNode;
  error?: boolean;
  slotProps?: DatePickerSlotProps<boolean>;
};
type DateFieldRef = ComponentRef<typeof DatePicker>;
const DateField = forwardRef<DateFieldRef, DateFieldProps>((props, ref) => {
  const { required, fullWidth, helperText, error, slotProps = {}, ...rest } = props;
  const { textField, ...restSlots } = slotProps;

  return (
    <DatePicker
      ref={ref}
      dayOfWeekFormatter={(day) =>
        formatDate(day, { weekday: 'long' }).slice(0, 2)
      }
      slotProps={{
        textField: {
          required,
          fullWidth,
          helperText,
          error,
          ...textField,
        },
        ...restSlots,
      }}
      {...rest}
    />
  );
});
DateField.displayName = 'DateField';
export default DateField;
